/**
 * Map list state and parsed list state to item render props
 */
export const getItemRenderState = ({ itemsById, disabledById, expandedById, groupsState, onItemClick, mapItemDataToProps, visibleFlattenIds, size = 'm', itemsState, selectedById, activeItemId, id, idToFlattenIndex, }, { defaultExpanded = true } = {}) => {
    var _a;
    const context = {
        visibleFlattenIndex: idToFlattenIndex[id],
        itemState: itemsState[id],
        groupState: groupsState[id],
        isLastItem: id === visibleFlattenIds[visibleFlattenIds.length - 1],
    };
    let expanded; // `undefined` value means than tree list will look as nested list without groups
    // isGroup
    if (groupsState[id] && expandedById) {
        expanded = (_a = expandedById[id]) !== null && _a !== void 0 ? _a : defaultExpanded;
    }
    const stateProps = Object.assign({ id,
        size,
        expanded, active: id === activeItemId, indentation: context.itemState.indentation, disabled: Boolean(disabledById === null || disabledById === void 0 ? void 0 : disabledById[id]), selected: Boolean(selectedById === null || selectedById === void 0 ? void 0 : selectedById[id]), onClick: onItemClick ? () => onItemClick(id) : undefined }, mapItemDataToProps(itemsById[id]));
    return { data: itemsById[id], props: stateProps, context };
};
